module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-4-9d749d64442a9551b320fd5fe03ea797.png";